import { useId } from 'react';

import { TextArea } from '@/components/Inputs';
import { UnitInput } from '@/components/UnitInput/UnitInput';

import s from './NavFooterSection.module.scss';

interface NavFooterSectionProps {
  maintenance: string;
  fuelTakenOn: [string, string];
  waterTakenOn: [string, string];
  onChange: (field: 'maintenance', value: string) => void;
  onFuelChange: (index: 0 | 1, value: string) => void;
  onWaterChange: (index: 0 | 1, value: string) => void;
}

interface FluidRowProps {
  label: string;
  values: [string, string];
  onChange: (index: 0 | 1, value: string) => void;
}

const INDEXES = [0, 1] as const;
const READING_LABELS = ['Start:', 'Finish:'] as const;

function FluidRow({ label, values, onChange }: FluidRowProps) {
  const id = useId();

  return (
    <div className={s.fluidRow}>
      <label htmlFor={`${id}-0`} className={s.fluidRowLabel}>
        {label}
      </label>
      {INDEXES.map((index) => (
        <div key={index} className={s.fluidReading}>
          <span className={s.fluidReadingLabel}>{READING_LABELS[index]}</span>
          <UnitInput
            compact
            id={`${id}-${index}`}
            aria-label={`${label} ${READING_LABELS[index].slice(0, -1).toLowerCase()}`}
            kind="volume"
            type="number"
            inputMode="decimal"
            min="0"
            step="any"
            value={values[index] || '0'}
            // `min` only stops the arrows; a typed minus is clamped here.
            onChange={(v) => onChange(index, Number(v) < 0 ? '0' : v)}
            className={s.fluidField}
          />
        </div>
      ))}
    </div>
  );
}

export function NavFooterSection({
  maintenance,
  fuelTakenOn,
  waterTakenOn,
  onChange,
  onFuelChange,
  onWaterChange,
}: NavFooterSectionProps) {
  return (
    <div className={s.root}>
      <div className={s.cell}>
        <label className={s.label}>Maintenance & Reminders</label>
        <TextArea
          label=""
          placeholder="Bilge pump due for service."
          value={maintenance}
          onChange={(e) => onChange('maintenance', e.target.value)}
        />
      </div>

      <div className={`${s.cell} ${s.cellCentered}`}>
        <FluidRow label="Fuel Aboard" values={fuelTakenOn} onChange={onFuelChange} />
        <FluidRow label="Water Aboard" values={waterTakenOn} onChange={onWaterChange} />
      </div>
    </div>
  );
}
